import React from 'react';

const ContainerHeader = ({ children }) => (
  <div className="flex flex-row items-center justify-between space-y-0 space-x-4">{children}</div>
);

export default ContainerHeader;
